/*!
 * Vaanaya custom cart drawer
 * Uses Shopify's Cart AJAX API (/cart.js, /cart/add.js, /cart/change.js) — no page reloads.
 * Exposes window.VaanayaCart { open, close, refresh, add }.
 * Emits 'vaanaya:cart:updated' on document with the cart in event.detail.
 */
(function () {
  'use strict';
  if (window.VaanayaCart) return;

  /* ---------- Config ---------- */
  var DEFAULTS = {
    // Must mirror the live GoKwik prepaid offer. Amounts in paise.
    prepaid: { enabled: true, type: 'flat', value: 0, max: 0, minCart: 0 }, // optional EXTRA prepaid discount; default none
    points: { enabled: true, rate: 0.10 },
    freeShippingThreshold: 0,           // paise; 0 hides the progress bar
    cod: { enabled: true, fee: 4900 },  // paise added to COD orders; shown to parents as 'save flat ₹49 on prepaid'
    imageSource: 'hero',
    freeShippingAlways: false,        // true = every order ships free; strip reads 'Free delivery in …'
    upsellOffer: {                    // price cut on 'Frequently added together' picks
      enabled: true, type: 'flat',    // 'flat' = amount off (paise), 'percent' = percent off listing price
      amount: 10000, percent: 10, maxOff: 0,   // maxOff (paise) caps a percent discount; 0 = no cap
      property: '_vaanaya_upsell',    // hidden line property the discount Function keys on
      variantMap: {}                  // optional: { listingVariantId: offerVariantId } if you use pre-priced offer variants
    },
    logoUrl: '',                      // logo image URL; empty shows a placeholder box
    logoTone: 'white',                // 'white' recolours a single-colour logo to white for the orange header; 'original' keeps its colours
    recommendations: {
      enabled: true, limit: 3,
      fallbackHandles: [],              // used when Shopify recommendations return too few
      excludeHandles: [],               // discontinued / not promoted
      benefits: {}                      // handle -> short benefit line
    },
    nativeDrawerSelectors: 'cart-drawer,#CartDrawer,cart-notification,#cart-notification,.cart-drawer',
    cartTriggerSelectors: 'a[href$="/cart"],[data-cart-toggle],#cart-icon-bubble',
    cartCountSelectors: '.cart-count-bubble span[aria-hidden],[data-cart-count]',
    interceptAddToCart: true,
    openOnAdd: true,
    checkout: { mode: 'auto', handler: '', themeButtonSelectors: '#CartDrawer-Checkout,#checkout,cart-drawer [name="checkout"],form[action*="/cart"] [name="checkout"]:not(#vcd-native-checkout)' },
    emptyCta: { label: 'Shop Vaanaya', url: '/collections/all' },
    delivery: { text: 'Delivers in 1\u20133 working days', short: '1\u20133 days', label: 'delivery to your doorstep' },
    bestseller: { handle: 'smart-growth-mix', label: 'Bestseller' },
    couponNote: 'Coupons apply at checkout',
    trust: [                          // icon: parents | returns | doctor
      { icon: 'parents', text: 'Trusted by 20,000+ parents' },
      { icon: 'returns', text: 'Easy returns & replacements' },
      { icon: 'doctor', text: 'Recommended by doctors' }
    ],
    qtyDebounce: 400,
    initialCart: null
  };

  function merge(a, b) {
    var out = Array.isArray(a) ? a.slice() : Object.assign({}, a);
    Object.keys(b || {}).forEach(function (k) {
      var v = b[k];
      out[k] = v && typeof v === 'object' && !Array.isArray(v) && a[k] && typeof a[k] === 'object' ? merge(a[k], v) : v;
    });
    return out;
  }
  var cfg = merge(DEFAULTS, window.VaanayaCartConfig || {});
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var nativeFetch = window.fetch.bind(window);

  /* ---------- State ---------- */
  var S = {
    cart: cfg.initialCart, compareAt: {}, hero: {}, justAdded: {}, best: null, fit: 0, recs: [], recsKey: '',
    pending: {}, timers: {}, queue: Promise.resolve(),
    open: false, loading: false, adding: false, checkingOut: false, lastFocus: null
  };

  /* ---------- Utils ---------- */
  function money(p) {
    p = Math.round(p || 0);
    var r = p / 100;
    return '\u20B9' + r.toLocaleString('en-IN', { minimumFractionDigits: p % 100 ? 2 : 0, maximumFractionDigits: 2 });
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function img(url, w) {
    if (!url) return '';
    if (typeof url === 'object') url = url.src || url.url || '';
    if (url.indexOf('//') === 0) url = 'https:' + url;
    if (url.indexOf('data:') === 0 || url.indexOf('cdn.shopify') === -1 && url.indexOf('/cdn/') === -1) return url;
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }
  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function isOurPath(url) { return /\/cart(\/(add|change|update|clear))?(\.js)?(\?|$)/.test(url); }

  function api(path, body, isForm) {
    var opts = { headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' } };
    if (body) {
      opts.method = 'POST';
      if (isForm) opts.body = body;
      else { opts.headers['Content-Type'] = 'application/json'; opts.body = JSON.stringify(body); }
    }
    opts.headers['X-Vaanaya-Cart'] = '1';
    return nativeFetch(ROOT + path, opts).then(function (res) {
      return res.json().catch(function () { return null; }).then(function (data) {
        if (!res.ok) {
          var msg = (data && (data.description || data.message)) || 'Couldn\u2019t update your cart. Check your connection and try again.';
          throw new Error(msg);
        }
        return data;
      });
    });
  }

  /* ---------- Totals ---------- */
  function qtyOf(it) { return S.pending.hasOwnProperty(it.key) ? S.pending[it.key] : it.quantity; }
  function prepaidOff(total) {
    var p = cfg.prepaid;
    if (!p.enabled || total <= 0 || total < p.minCart) return 0;
    var d = p.type === 'percent' ? total * p.value / 100 : p.value;
    if (p.max) d = Math.min(d, p.max);
    d = Math.floor(Math.min(d, total) / 100) * 100; // whole rupees, never round up
    return d;
  }
  function totals() {
    var c = S.cart, mrp = 0, total = c.total_price, count = 0;
    c.items.forEach(function (it) {
      var q = qtyOf(it); count += q;
      var ca = S.compareAt[it.variant_id];
      var unit = ca && ca > it.original_price ? ca : it.original_price;
      mrp += unit * q;
      if (q !== it.quantity) total += (q - it.quantity) * it.final_price; // optimistic until server responds
    });
    total = Math.max(0, total);
    var pre = prepaidOff(total);
    var payable = total - pre;
    return {
      count: count, mrp: mrp, total: total,
      productOff: Math.max(0, mrp - total), prepaid: pre, payable: payable,
      cod: total + (cfg.cod.enabled ? cfg.cod.fee || 0 : 0),
      prepaidSave: (cfg.cod.enabled ? cfg.cod.fee || 0 : 0) + pre,
      saving: Math.max(0, mrp - total),
      points: cfg.points.enabled ? Math.floor(payable * cfg.points.rate / 100) * 100 : 0
    };
  }

  /* ---------- DOM ---------- */
  var root = document.getElementById('vcd-root');
  if (!root) { console.warn('[Vaanaya cart] #vcd-root not found — is the snippet rendered?'); return; }
  var panel = $('.vcd__panel', root), body = $('#vcd-dyn', root), foot = $('.vcd__foot', root),
      strip = $('#vcd-strip', root), moment = $('.vcd-moment', root),
      toastEl = $('.vcd-toast', root), live = $('.vcd-sr', root);

  // Hide the theme's native drawer/notification so only this one shows
  if (cfg.nativeDrawerSelectors) {
    var st = document.createElement('style');
    st.textContent = cfg.nativeDrawerSelectors.split(',').map(function (x) { return x.trim() + ':not(#vcd-root *)'; }).join(',') +
      '{display:none!important;visibility:hidden!important}';
    document.head.appendChild(st);
  }

  var ICON_PLUS = '<svg width="12" height="12" viewBox="0 0 12 12" aria-hidden="true"><path d="M2 6h8M6 2v8" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>';
  var ICON_MINUS = '<svg width="12" height="12" viewBox="0 0 12 12" aria-hidden="true"><path d="M2 6h8" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>';
  var ICON_CHECK = '<svg width="14" height="14" viewBox="0 0 14 14" aria-hidden="true"><circle cx="7" cy="7" r="7" fill="#EA7331"/><path d="M4 7.2l2 2 4-4.2" stroke="#fff" stroke-width="1.6" fill="none" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var ICON_TRUCK = '<svg width="16" height="12" viewBox="0 0 16 12" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linejoin="round"><path d="M1 1.5h8.5v7H1zM9.5 4h3l2.5 2.6v1.9h-5.5"/><circle cx="4" cy="9.6" r="1.4" fill="#EA7331"/><circle cx="12" cy="9.6" r="1.4" fill="#EA7331"/></svg>';

  function hasPrepaidSave() { return cfg.cod.enabled && cfg.cod.fee > 0 || cfg.prepaid.enabled && cfg.prepaid.value > 0; }
  function shortTitle(t) {
    t = String(t || '').split(' | ')[0].replace(/\s*\(\s*\d+\s*(g|gm|ml|kg)\s*\)\s*$/i, '').trim();
    if (t === t.toUpperCase() && /[A-Z]/.test(t)) t = t.toLowerCase().replace(/(^|[\s(])([a-z])/g, function (m, a, b) { return a + b.toUpperCase(); });
    return t;
  }
  function offerOn() { var o = cfg.upsellOffer; return o.enabled && (o.type === 'percent' ? o.percent > 0 : o.amount > 0); }
  // Formula: discount is worked out from the product's LIVE Shopify price every time
  function offerOff(price) {
    var o = cfg.upsellOffer;
    if (!offerOn()) return 0;
    var off = o.type === 'percent' ? Math.round(price * o.percent / 100 / 100) * 100 : o.amount; // percent rounds to whole rupees
    if (o.maxOff) off = Math.min(off, o.maxOff);
    return Math.max(0, Math.min(off, price));
  }
  function offerPrice(p) { return offerActive() ? p - offerOff(p) : p; }
  // The cart offer only applies alongside at least one full-price item, so it always grows the order
  function offerActive() {
    if (!offerOn() || !S.cart) return false;
    return S.cart.items.some(function (it) { return qtyOf(it) > 0 && !isOfferLine(it); });
  }
  function offerLabel() { var o = cfg.upsellOffer; return (o.type === 'percent' ? o.percent + '%' : money(o.amount)) + ' off each'; }
  function isOfferLine(it) { return it.properties && it.properties[cfg.upsellOffer.property]; }
  function heroOf(it) { return cfg.imageSource === 'hero' && S.hero[it.handle] ? S.hero[it.handle] : it.image; }

  /* fit levels — recommendations never drop below the configured count:
     0 full, 1 tighter spacing, 2 smaller cart images + compact header, 3 compact rec cards, 4 dense cart rows, 5 body scrolls */
  function recLimit() { return cfg.recommendations.limit; }

  function itemHTML(it) {
    var q = qtyOf(it);
    if (q === 0) return '';
    var ca = S.compareAt[it.variant_id];
    var unitMrp = ca && ca > it.final_price ? ca : (it.original_price > it.final_price ? it.original_price : 0);
    var variant = it.variant_title && it.variant_title !== 'Default Title' ? it.variant_title : '';
    var cls = 'vcd-item' + (S.pending.hasOwnProperty(it.key) ? ' is-busy' : '') + (S.justAdded[it.variant_id] ? ' is-new' : '');
    var im = heroOf(it);
    return '<li class="' + cls + '" data-key="' + esc(it.key) + '" data-vid="' + it.variant_id + '">' +
      '<a class="vcd-plinth vcd-item__img" href="' + esc(it.url) + '" tabindex="-1" aria-hidden="true">' +
        (im ? '<img src="' + esc(img(im, 240)) + '" alt="" width="80" height="80">' : '') + '</a>' +
      '<div class="vcd-item__main"><p class="vcd-item__tag">Just added</p>' + (isOfferLine(it) ? '<p class="vcd-item__offer">Cart offer</p>' : '') + '<a class="vcd-item__title" href="' + esc(it.url) + '">' + esc(shortTitle(it.product_title)) + '</a>' +
        (variant ? '<p class="vcd-item__variant">' + esc(variant) + '</p>' : '') +
        '<div class="vcd-item__row"><div class="vcd-qty" role="group" aria-label="Quantity for ' + esc(shortTitle(it.product_title)) + '">' +
          '<button type="button" data-act="dec" data-fid="dec-' + esc(it.key) + '" aria-label="Decrease quantity"' + (q <= 1 ? ' disabled' : '') + '>' + ICON_MINUS + '</button>' +
          '<span>' + q + '</span>' +
          '<button type="button" data-act="inc" data-fid="inc-' + esc(it.key) + '" aria-label="Increase quantity">' + ICON_PLUS + '</button>' +
        '</div><button type="button" class="vcd-item__remove" data-act="remove">Remove</button></div></div>' +
      (function () {
        var st = S.addAnim && S.addAnim.v[it.variant_id] ? lineAnimState(S.addAnim.v[it.variant_id]) : null;
        var wait = !st && S.justAdded[it.variant_id] && !S.addAnimDone;   // hold the price back until the drop can play
        return '<div class="vcd-item__price' + (st && !st.done ? ' is-animating' : '') + (wait ? ' is-wait' : '') + '"><strong class="vcd-lp' + (st ? st.cls : '') + '">' + (st ? st.text : money(it.final_price * q)) + '</strong>';
      })() +
        (unitMrp ? '<s>' + money(unitMrp * q) + '</s>' : '') +
        (q > 1 ? '<small>' + money(it.final_price) + ' each</small>' : '') +
      '</div></li>';
  }

  function pointsHTML(t) {
    if (!cfg.points.enabled || !t.points) return '';
    return '<div class="vcd-pts"><span class="vcd-pts__mark" aria-hidden="true">V</span>' +
      '<p class="vcd-pts__t">You\u2019ll earn <b>' + money(t.points) + '</b> in Vaanaya Points<span>' + Math.round(cfg.points.rate * 100) + '% back on what you pay</span></p></div>';
  }

  function recsHTML() {
    var n = recLimit();
    if (!cfg.recommendations.enabled || !n) return '';
    if (!S.recs.length && S.recsLoading) {
      var sk = ''; for (var k = 0; k < n; k++) sk += '<div class="vcd-rec is-skel"><div class="vcd-plinth vcd-rec__img"></div><div class="vcd-rec__body"><p class="vcd-rec__name">&nbsp;<br>&nbsp;</p><div class="vcd-rec__foot"><span class="vcd-rec__price"><s>&nbsp;</s>&nbsp;</span><span class="vcd-rec__add"></span></div></div></div>';
      return '<section class="vcd-upsell" aria-hidden="true"><h3 class="vcd-h">Frequently added together' + (offerActive() ? '<span class="vcd-h__n">' + offerLabel() + '</span>' : '') + '</h3><div class="vcd-recs n' + n + '">' + sk + '</div></section>';
    }
    if (!S.recs.length) return '';
    var list = S.recs.slice(0, n), solo = list.length === 1, many = list.length >= 3;
    return '<section class="vcd-upsell" aria-label="Frequently added together"><h3 class="vcd-h">Frequently added together' +
      (offerActive() ? '<span class="vcd-h__n">' + offerLabel() + '</span>' : '') + '</h3><div class="vcd-recs n' + list.length + (solo ? ' is-solo' : '') + '">' +
      list.map(function (p) {
        var b = solo ? (cfg.recommendations.benefits[p.handle] || '') : '';
        return '<div class="vcd-rec"><div class="vcd-plinth vcd-rec__img">' +
          (p.image ? '<img src="' + esc(img(p.image, 300)) + '" alt="" loading="lazy">' : '') + '</div>' +
          '<div class="vcd-rec__body"><p class="vcd-rec__name">' + esc(shortTitle(p.title)) + '</p>' + (b ? '<p class="vcd-rec__benefit">' + esc(b) + '</p>' : '') +
          '<div class="vcd-rec__foot"><span class="vcd-rec__price">' + (offerActive() ? '<s>' + money(p.price) + '</s>' : '') + money(offerPrice(p.price)) + '</span>' +
          '<button type="button" class="vcd-rec__add" data-act="add-rec" data-variant="' + p.variantId + '" data-fid="rec-' + p.variantId +
          '" aria-label="Add ' + esc(shortTitle(p.title)) + ' for ' + money(offerPrice(p.price)) + '">' + ICON_PLUS + (many ? '' : '<span>Add</span>') + '</button></div></div></div>';
      }).join('') + '</div></section>';
  }

  function summaryHTML(t) {
    return '<div class="vcd-sum">' + (t.saving ? '<p>You\u2019re saving <b>' + money(t.saving) + '</b></p>' : '') +
      '<p class="vcd-coupon' + (S.couponIn ? ' is-in' : '') + '">' + esc(cfg.couponNote) + '</p></div>';
  }

  var TRUST_ICONS = {
    parents: '<path d="M6 7.2a2.4 2.4 0 1 0 0-4.8 2.4 2.4 0 0 0 0 4.8zM1.8 14c0-2.4 1.9-4.2 4.2-4.2S10.2 11.6 10.2 14M11.6 7.6a2 2 0 1 0 0-4M12.4 9.9c1.1.5 1.8 1.6 1.8 2.9"/>',
    returns: '<path d="M2.5 6.5A5.6 5.6 0 0 1 13 5M13.5 9.5A5.6 5.6 0 0 1 3 11"/><path d="M13.2 1.8V5H10M2.8 14.2V11H6"/>',
    doctor: '<path d="M8 14.2s-5.4-3.1-5.4-7A3 3 0 0 1 8 5.3a3 3 0 0 1 5.4 1.9c0 3.9-5.4 7-5.4 7z"/><path d="M8 7.2v3.2M6.4 8.8h3.2"/>'
  };
  function trustHTML() {
    if (!cfg.trust || !cfg.trust.length) return '';
    return '<ul class="vcd-trust" aria-label="Why parents trust Vaanaya">' + cfg.trust.map(function (b) {
      return '<li><svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
        (TRUST_ICONS[b.icon] || '') + '</svg><span>' + esc(b.text) + '</span></li>';
    }).join('') + '</ul>';
  }

  function emptyHTML() {
    var stats = '';
    if (cfg.points.enabled) stats += '<div class="vcd-stat"><b>' + Math.round(cfg.points.rate * 100) + '% back</b><span>as Vaanaya Points on every order</span></div>';
    if (hasPrepaidSave()) stats += '<div class="vcd-stat"><b>' + money((cfg.cod.enabled ? cfg.cod.fee : 0) + (cfg.prepaid.type === 'flat' ? cfg.prepaid.value : 0)) + ' off</b><span>flat, when you pay online</span></div>';
    var b = S.best, best = '';
    if (b) {
      best = '<div class="vcd-best"><div class="vcd-plinth vcd-best__img">' + (b.image ? '<img src="' + esc(img(b.image, 480)) + '" alt="">' : '') +
        '<span class="vcd-best__k">' + esc(cfg.bestseller.label) + '</span></div>' +
        '<div class="vcd-best__body"><p class="vcd-best__n">' + esc(shortTitle(b.title)) + '<span>' + money(b.price) + '</span></p>' +
        '<div class="vcd-best__v">' + b.variants.map(function (v) {
          var label = v.title === 'Default Title' ? 'Add to cart' : 'Add ' + v.title;
          return '<button type="button" data-act="add-best" data-variant="' + v.id + '" data-fid="best-' + v.id + '">' + esc(label) + '</button>';
        }).join('') + '</div></div></div>';
    }
    return '<div><h2 class="vcd-empty__t" id="vcd-title">Your cart is empty</h2><p class="vcd-empty__s">Every Vaanaya order comes with</p></div>' +
      (stats ? '<div class="vcd-stats">' + stats + '</div>' : '') + best + trustHTML();
  }

  function stripHTML(t, empty) {
    var th = cfg.freeShippingThreshold;
    var d = '<span class="vcd-strip__d">' + ICON_TRUCK + esc(cfg.freeShippingAlways ? cfg.delivery.freeText || cfg.delivery.text : cfg.delivery.text) + '</span>';
    if (empty || !(th > 0)) return '<div class="vcd-strip">' + d + '</div>';
    var done = t.total >= th, pct = Math.min(100, t.total / th * 100);
    var ship = done ? '<span class="vcd-strip__s"><b>Free shipping</b> unlocked</span>' :
      '<span class="vcd-strip__s"><b>' + money(th - t.total) + '</b> to free shipping</span>';
    return '<div class="vcd-strip vcd-strip--bar">' + d + '<div class="vcd-strip__row">' + ship +
      '<div class="vcd-strip__bar" role="progressbar" aria-valuemin="0" aria-valuemax="100" aria-valuenow="' + Math.round(pct) +
      '" aria-label="Progress to free shipping"><span style="width:' + pct + '%"></span></div></div></div>';
  }

  function draw() {
    for (var i = 1; i <= 5; i++) root.classList.toggle('vcd--l' + i, S.fit >= i);
    if (!S.cart) {
      body.innerHTML = '<div class="vcd-skel"></div><div class="vcd-skel"></div>';
      setFoot(''); strip.innerHTML = stripHTML(null, true); return;
    }
    var visible = S.cart.items.filter(function (it) { return qtyOf(it) > 0; });
    var t = totals();
    strip.innerHTML = stripHTML(t, !visible.length);
    root.classList.toggle('is-empty', !visible.length);

    if (!visible.length) {
      body.innerHTML = emptyHTML();
      setFoot('<a class="vcd-cta" href="' + esc(cfg.emptyCta.url) + '"><span>' + esc(cfg.emptyCta.label) + '</span></a>');
      return;
    }

    body.innerHTML = '<section><h2 class="vcd-h" id="vcd-title">Your cart<span class="vcd-h__n">' + t.count + (t.count === 1 ? ' item' : ' items') + '</span></h2>' +
      '<div class="vcd-items"><ul aria-label="Cart items">' + visible.map(itemHTML).join('') + '</ul>' + summaryHTML(t) + '</div></section>' +
      recsHTML();
    // Points aur trust badges dono footer mein hain, body mein nahi: body scroll aur clip hota hai,
    // footer kabhi nahi — to Pay button ke upar ka hissa hamesha bhara aur dikhta rehta hai.
    root.classList.toggle('is-updating', Object.keys(S.pending).length > 0);
    if (S.open && !S.addAnimDone && Object.keys(S.justAdded).length) setTimeout(startAddAnim, 0);

    var busy = Object.keys(S.pending).length > 0;
    setFoot(
      pointsHTML(t) + trustHTML() +
      '<button type="button" class="vcd-cta" data-act="checkout" data-mode="prepaid"' + (busy ? ' disabled' : '') + '><span>Pay <span class="vcd-amt">' + money(t.payable) + '</span> &amp; checkout</span></button>' +
      (t.prepaidSave ? '<div class="vcd-foot__row"><span class="vcd-foot__save">' + ICON_CHECK + 'COD fee <span class="vcd-fee"><span class="vcd-fee__old">' + money(t.prepaidSave) + '</span> <b class="vcd-fee__new">' + money(0) + '</b></span> on prepaid</span>' +
        (cfg.cod.enabled ? '<button type="button" class="vcd-cod" data-act="checkout" data-mode="cod">Pay ' + money(t.cod) + ' on delivery</button>' : '') + '</div>' : ''));
    if (S.holdOpenAnim) { var ha = foot.querySelector('.vcd-amt'); if (ha) ha.classList.add('is-wait'); }
    live.textContent = 'Total payable ' + money(t.payable);
  }

  // Only touch the footer when its content really changes, so the opening animation isn't interrupted
  function setFoot(html) { if (S.footHTML !== html) { S.footHTML = html; foot.innerHTML = html; } }

  function afterAdd() {
    if (!cfg.openOnAdd) return;
    if (!S.open) open(); else startAddAnim();
  }

  /* Newly added product: lands at its higher price (MRP, or listing price for a cart offer), the price is struck
     and counts down to what they pay. Time-based, so re-renders mid-way pick up where it is. ~1.5s total. */
  var ANIM = { strike: 250, count: 700, end: 1500 };
  function lineAnimState(a) {
    var e = performance.now() - S.addAnim.t0;
    if (e >= ANIM.end) return { text: money(a.to), cls: S.addAnim.popped ? '' : ' is-pop', done: true };
    if (e < ANIM.count) return { text: money(a.from), cls: ' is-anim' + (e >= ANIM.strike ? ' is-struck' : '') };
    var k = (e - ANIM.count) / (ANIM.end - ANIM.count), ease = 1 - Math.pow(1 - k, 3);
    return { text: money(Math.round((a.from + (a.to - a.from) * ease) / 100) * 100), cls: ' is-anim is-struck is-count' };
  }
  function startAddAnim() {
    if (!S.open || !S.cart || !S.addFresh || S.addAnimDone || !Object.keys(S.justAdded).length) return;
    var waiting = S.cart.items.some(function (it) { return S.justAdded[it.variant_id] && !(it.variant_id in S.compareAt); });
    if (waiting) return;                                   // MRP not loaded yet; the next render starts it
    S.addAnimDone = true;
    root.querySelectorAll('.vcd-item__price.is-wait').forEach(function (el) { el.classList.remove('is-wait'); });
    if (reducedMotion()) { S.holdOpenAnim = false; return revealCoupon(0); }
    var v = {}, any = false;
    S.cart.items.forEach(function (it) {
      if (!S.justAdded[it.variant_id] || qtyOf(it) < 1) return;
      var q = qtyOf(it), ca = S.compareAt[it.variant_id] || 0;
      var from = isOfferLine(it) && it.original_price > it.final_price ? it.original_price : Math.max(ca, it.original_price);
      if (from * q > it.final_price * q) { v[it.variant_id] = { from: from * q, to: it.final_price * q }; any = true; }
    });
    if (!any) { if (S.holdOpenAnim) { S.holdOpenAnim = false; animateOpen(); } focusFor(10); return revealCoupon(0); }
    focusFor(ANIM.end + 80);
    S.addAnim = { t0: performance.now(), v: v, popped: false };
    if (S.holdOpenAnim) { S.holdOpenAnim = false; animateOpen(); }     // checkout price drops in step with the line
    (function tick() {
      if (!S.addAnim) return;
      Object.keys(S.addAnim.v).forEach(function (vid) {
        var el = root.querySelector('.vcd-item[data-vid="' + vid + '"] .vcd-lp'); if (!el) return;
        var st = lineAnimState(S.addAnim.v[vid]);
        el.textContent = st.text; el.className = 'vcd-lp' + st.cls;
        el.parentNode.classList.toggle('is-animating', !st.done);
      });
      if (performance.now() - S.addAnim.t0 < ANIM.end) requestAnimationFrame(tick);
      else { S.addAnim.popped = true; setTimeout(function () { S.addAnim = null; }, 400); }
    })();
    revealCoupon(ANIM.end + 100);
    settleAmount(ANIM.end + 200);
  }
  function animateAdded() { startAddAnim(); }

  // Focus mode: while a price animation plays, only the cart, header and checkout stay on screen.
  // Everything else keeps its space (no layout jump) and fades back in, one by one, when it ends.
  function focusFor(ms) {
    root.classList.add('is-focus');
    clearTimeout(S.focusT);
    S.focusT = setTimeout(function () { root.classList.remove('is-focus'); }, ms);
  }

  function revealCoupon(delay) {
    if (S.couponIn) return;
    setTimeout(function () { S.couponIn = true; var c = root.querySelector('.vcd-coupon'); if (c) c.classList.add('is-in'); }, delay);
  }
  function reducedMotion() { return window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches; }

  /* Opening moment (< 2s): MRP is struck through and counts down to the payable price; COD fee ₹49 is struck to ₹0 */
  // The checkout amount is the one number that must always be right. The countdown writes into
  // a .vcd-amt node that a re-render can replace mid-flight, so every run carries a sequence
  // number (stale loops stop writing) and a settle pass re-reads the live total at the end.
  function settleAmount(delay) {
    clearTimeout(S.settleT);
    S.settleT = setTimeout(function () {
      if (!S.open || !S.cart) return;
      var el = foot.querySelector('.vcd-amt');
      if (!el) return;
      var right = money(totals().payable);
      el.classList.remove('is-anim', 'is-struck', 'is-count', 'is-wait');
      if (el.textContent !== right) el.textContent = right;
    }, delay);
  }

  function animateOpen() {
    if (!S.cart) return;
    if (reducedMotion()) return revealCoupon(0);
    var t = totals(), amt = foot.querySelector('.vcd-amt'), fee = foot.querySelector('.vcd-fee');
    if (amt) amt.classList.remove('is-wait');
    if (amt && t.mrp > t.payable || fee) focusFor(1550);
    clearTimeout(S.animT1); clearTimeout(S.animT2); clearTimeout(S.animT3);
    var seq = S.openSeq = (S.openSeq || 0) + 1;
    if (amt && t.mrp > t.payable) {
      amt.classList.remove('is-pop', 'is-count'); amt.classList.add('is-anim'); amt.textContent = money(t.mrp);
      S.animT1 = setTimeout(function () { if (seq === S.openSeq) amt.classList.add('is-struck'); }, 250);
      S.animT2 = setTimeout(function () {
        if (seq !== S.openSeq) return;
        amt.classList.add('is-count');
        var from = t.mrp, d = 800, t0 = performance.now();
        (function step(now) {
          if (seq !== S.openSeq) return;                       // a newer run owns the number now
          var to = totals().payable;                           // live total, not the one captured at t0
          var k = Math.min(1, (now - t0) / d), e = 1 - Math.pow(1 - k, 3);
          amt.textContent = money(Math.round((from + (to - from) * e) / 100) * 100);
          if (k < 1) requestAnimationFrame(step);
          else { amt.textContent = money(to); amt.classList.remove('is-anim', 'is-struck', 'is-count'); amt.classList.add('is-pop'); }
        })(t0);
      }, 700);
      settleAmount(1700);                                      // whatever happened above, end on the real figure
    } else settleAmount(60);
    revealCoupon(1600);
    if (fee) {
      fee.classList.remove('is-go'); fee.classList.add('is-anim'); void fee.offsetWidth;
      S.animT3 = setTimeout(function () { fee.classList.add('is-go'); }, 1000);
    }
  }

  function overflows() { return body.scrollHeight > body.clientHeight + 1; }

  function render() {
    var fid = document.activeElement && root.contains(document.activeElement) && document.activeElement.getAttribute('data-fid');
    S.fit = 0; draw();
    while (S.fit < 5 && overflows()) { S.fit++; draw(); }
    if (fid) { var el = root.querySelector('[data-fid="' + fid + '"]'); if (el && !el.disabled) el.focus(); }
  }
  var rT, lastW = window.innerWidth;
  window.addEventListener('resize', function () {
    if (window.innerWidth === lastW) return;            // mobile URL bar show/hide changes height only: ignore
    lastW = window.innerWidth;
    clearTimeout(rT); rT = setTimeout(function () { if (S.open) render(); }, 120);
  });

  /* ---------- Data sync ---------- */
  function updateBubbles(cart) {
    if (!cfg.cartCountSelectors) return;
    document.querySelectorAll(cfg.cartCountSelectors).forEach(function (el) {
      if (!root.contains(el)) el.textContent = cart.item_count;
    });
  }

  function loadCompareAt(cart) {
    var handles = {};
    cart.items.forEach(function (it) { if (!(it.variant_id in S.compareAt)) handles[it.handle] = 1; });
    var list = Object.keys(handles);
    if (!list.length) return Promise.resolve();
    return Promise.all(list.map(function (h) {
      return api('products/' + encodeURIComponent(h) + '.js').then(function (p) {
        (p.variants || []).forEach(function (v) { S.compareAt[v.id] = v.compare_at_price || 0; });
        S.hero[h] = p.featured_image || (p.images && p.images[0]) || '';
      }).catch(function () {
        cart.items.forEach(function (it) { if (it.handle === h) S.compareAt[it.variant_id] = 0; });
      });
    }));
  }

  function normalizeProduct(p) {
    var v = (p.variants || []).filter(function (x) { return x.available; })[0];
    if (!v) return null;
    var price = typeof v.price === 'string' ? Math.round(parseFloat(v.price) * 100) : v.price; // products.json uses rupee strings
    var im = p.featured_image || (p.images && p.images[0]) || (v.featured_image && v.featured_image.src);
    return { id: p.id, handle: p.handle, title: p.title, price: price, variantId: v.id, image: im };
  }

  function loadRecs(cart) {
    var rc = cfg.recommendations;
    if (!rc.enabled || !cart.items.length) { S.recs = []; return Promise.resolve(); }
    var inCart = {}; cart.items.forEach(function (it) { inCart[it.product_id] = 1; inCart[it.handle] = 1; });
    var key = Object.keys(inCart).sort().join('|');
    if (key === S.recsKey) return Promise.resolve();
    S.recsKey = key; S.recsLoading = true; S.recs = [];
    var exclude = {}; rc.excludeHandles.forEach(function (h) { exclude[h] = 1; });
    var seed = cart.items[0].product_id, picked = [], seen = {};

    // Manual mode: the picks come only from your own lists, in your own order.
    // pairs[<handle in cart>] wins; otherwise defaultPicks. Shopify's own recommendations
    // are never asked, so nothing unexpected can appear.
    function byHandles(list) {
      var want = [], seenH = {};
      (list || []).forEach(function (h) {
        if (!h || seenH[h] || inCart[h] || exclude[h]) return;
        seenH[h] = 1; want.push(h);
      });
      if (!want.length) return Promise.resolve();
      return Promise.all(want.map(function (h) {
        return api('products/' + encodeURIComponent(h) + '.js').catch(function () { return null; });
      })).then(take);                                  // Promise.all keeps your order
    }

    if (rc.mode === 'manual') {
      var listed = [];
      cart.items.forEach(function (it) {              // every product in the cart gets a say
        (rc.pairs && rc.pairs[it.handle] || []).forEach(function (h) { listed.push(h); });
      });
      (rc.defaultPicks || rc.fallbackHandles || []).forEach(function (h) { listed.push(h); });
      return byHandles(listed).then(function () {
        if (S.recsKey === key) { S.recs = picked; S.recsLoading = false; }
      });
    }

    function take(list) {
      (list || []).forEach(function (p) {
        if (picked.length >= rc.limit || !p || seen[p.handle] || inCart[p.id] || inCart[p.handle] || exclude[p.handle]) return;
        var n = normalizeProduct(p); if (!n) return;
        seen[p.handle] = 1; picked.push(n);
      });
    }
    function reco(intent) {
      return api('recommendations/products.json?product_id=' + seed + '&limit=8&intent=' + intent)
        .then(function (d) { take(d.products); }).catch(function () {});
    }
    return reco('complementary')
      .then(function () { if (picked.length < rc.limit) return reco('related'); })
      .then(function () {
        if (picked.length >= rc.limit) return;
        return Promise.all(rc.fallbackHandles.filter(function (h) { return !inCart[h] && !exclude[h]; }).map(function (h) {
          return api('products/' + encodeURIComponent(h) + '.js').catch(function () { return null; });
        })).then(take);
      })
      .then(function () {
        // Still short? Fill from the full catalogue so parents always see the configured number of picks
        if (picked.length >= rc.limit) return;
        return api('collections/all/products.json?limit=30').then(function (d) { take(d.products); }).catch(function () {});
      })
      .then(function () { if (S.recsKey === key) { S.recs = picked; S.recsLoading = false; } });
  }

  function loadBest(cart) {
    if (S.best || S.bestTried || cart.items.length || !cfg.bestseller.handle) return Promise.resolve();
    S.bestTried = true;
    return api('products/' + encodeURIComponent(cfg.bestseller.handle) + '.js').then(function (p) {
      var vs = (p.variants || []).filter(function (v) { return v.available; }).slice(0, 3);
      if (!vs.length) return;
      S.best = { title: p.title, image: p.featured_image, price: vs[0].price, variants: vs };
    }).catch(function () {});
  }

  function cartSig(c) { return c ? c.total_price + '|' + c.items.map(function (i) { return i.key + ':' + i.quantity + ':' + i.final_price; }).join(',') : ''; }
  function setCart(cart) {
    S.addFresh = true;
    var same = S.cart && cartSig(S.cart) === cartSig(cart) && !Object.keys(S.pending).length;
    S.cart = cart;
    if (same && !S.recsLoading) { updateBubbles(cart); return Promise.resolve(); }
    updateBubbles(cart);
    render();
    document.dispatchEvent(new CustomEvent('vaanaya:cart:updated', { detail: { cart: cart } }));
    return Promise.all([loadCompareAt(cart), loadRecs(cart), loadBest(cart)]).then(render);
  }

  function refresh() {
    return api('cart.js').then(setCart).catch(function (e) { toast(e.message); });
  }

  /* ---------- Mutations (serialised to avoid racing cart writes) ---------- */
  function enqueue(fn) { S.queue = S.queue.then(fn, fn); return S.queue; }

  function commitQty(key) {
    return enqueue(function () {
      if (!S.pending.hasOwnProperty(key)) return;
      var q = S.pending[key];
      return api('cart/change.js', { id: key, quantity: q }).then(function (cart) {
        if (S.pending[key] === q) delete S.pending[key];
        return setCart(cart);
      }).catch(function (e) {
        delete S.pending[key]; toast(e.message); return refresh();
      });
    });
  }

  function setQty(key, q, immediate) {
    S.pending[key] = Math.max(0, q);
    render();
    clearTimeout(S.timers[key]);
    if (immediate) commitQty(key);
    else S.timers[key] = setTimeout(function () { commitQty(key); }, cfg.qtyDebounce);
  }

  function markAdded(res) {
    var list = res && (res.items || (res.variant_id ? [res] : [])) || [];
    S.justAdded = {}; S.addAnimDone = false; S.addFresh = false;
    list.forEach(function (x) { S.justAdded[x.variant_id || x.id] = 1; });
    clearTimeout(S.addedT);
    S.addedT = setTimeout(function () { S.justAdded = {}; root.querySelectorAll('.vcd-item.is-new').forEach(function (el) { el.classList.remove('is-new'); }); }, 4000);
  }

  // Upsell picks: either swap to a pre-priced offer variant, or tag the line so the discount Function takes ₹100 off
  function upsellLine(id) {
    var o = cfg.upsellOffer;
    if (!offerActive()) return { id: id, quantity: 1 };
    if (o.variantMap[id]) return { id: Number(o.variantMap[id]), quantity: 1 };
    var rec = S.recs.filter(function (r) { return r.variantId === id; })[0];
    var props = {}; props[o.property] = String(rec ? offerOff(rec.price) : offerOff(0) || o.amount); // discount per unit, in paise
    return { id: id, quantity: 1, properties: props };
  }

  function add(items, btn) {
    if (S.adding) return Promise.resolve();
    S.adding = true; if (btn) btn.classList.add('is-loading');
    var isForm = items instanceof FormData;
    return enqueue(function () {
      return api('cart/add.js', isForm ? items : { items: items }, isForm)
        .then(function (res) { markAdded(res); if (cfg.openOnAdd && !S.open) { S.cart = null; S.footHTML = null; if (!reducedMotion()) { S.holdOpenAnim = true; focusFor(4000); } open(); } return refresh(); })
        .then(function () { afterAdd(); })
        .catch(function (e) { open(); toast(e.message); });
    }).then(function () { S.adding = false; if (btn) btn.classList.remove('is-loading'); });
  }

  /* ---------- Checkout (GoKwik-aware, never bypasses existing logic) ---------- */
  function checkout(btn) {
    if (S.checkingOut) return;
    S.checkingOut = true; btn.classList.add('is-loading');
    var reset = setTimeout(function () { S.checkingOut = false; btn.classList.remove('is-loading'); }, 5000);
    Object.keys(S.timers).forEach(function (k) { clearTimeout(S.timers[k]); commitQty(k); });
    S.queue.then(function () {
      var custom = cfg.checkout.handler && window[cfg.checkout.handler];
      if (cfg.checkout.mode !== 'native') {
        if (typeof custom === 'function') return custom(btn);
        if (typeof window.onCheckoutClick === 'function') return window.onCheckoutClick(btn); // GoKwik's standard hook
      }
      // Click the theme's own checkout button: whatever checkout the store uses (GoKwik etc.) is already bound to it
      if (cfg.checkout.mode !== 'native') {
        var own = document.querySelector(cfg.checkout.themeButtonSelectors);
        if (own) return own.click();
      }
      var nb = document.getElementById('vcd-native-checkout');
      if (nb) return nb.click();
      window.location.href = ROOT + 'checkout';
    }).catch(function () {
      clearTimeout(reset); S.checkingOut = false; btn.classList.remove('is-loading');
      toast('Couldn\u2019t open checkout. Please try again.');
    });
  }

  /* ---------- Open / close ---------- */
  var fontReady = false;
  function whenFontReady(fn) {
    if (fontReady || !document.fonts || !document.fonts.load) return fn();
    var done = false, finish = function () { if (done) return; done = true; fontReady = true; fn(); };
    Promise.all([document.fonts.load("600 16px Poppins"), document.fonts.load("400 14px Inter")]).then(finish, finish);
    setTimeout(finish, 350);
  }

  function open() {
    if (S.open) return;
    S.open = true; S.lastFocus = document.activeElement;
    root.classList.add('is-open'); root.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('vcd-lock');
    var go = function () {
      render();
      if (Object.keys(S.justAdded).length && !S.addAnimDone && !reducedMotion()) {    // add animation will start both
        S.holdOpenAnim = true; focusFor(4000);
        var a = foot.querySelector('.vcd-amt'); if (a) a.classList.add('is-wait');
      }
      else animateOpen();
      animateAdded();
    };
    if (!S.cart) refresh().then(go); else whenFontReady(go);
    setTimeout(function () { panel.focus({ preventScroll: true }); }, 60);
  }
  function close() {
    if (!S.open) return;
    clearTimeout(S.focusT); root.classList.remove('is-focus');
    S.open = false;
    root.classList.remove('is-open'); root.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('vcd-lock');
    if (S.lastFocus && S.lastFocus.focus) S.lastFocus.focus({ preventScroll: true });
  }

  var toastT;
  function toast(msg) {
    toastEl.textContent = msg; toastEl.classList.add('is-on');
    clearTimeout(toastT); toastT = setTimeout(function () { toastEl.classList.remove('is-on'); }, 3800);
  }

  /* ---------- Events ---------- */
  root.addEventListener('click', function (e) {
    var t = e.target.closest('[data-act],.vcd__overlay,.vcd__close');
    if (!t) return;
    if (t.classList.contains('vcd__overlay') || t.classList.contains('vcd__close')) return close();
    var act = t.getAttribute('data-act'), li = t.closest('.vcd-item'), key = li && li.getAttribute('data-key');
    var it = key && S.cart.items.filter(function (x) { return x.key === key; })[0];
    if (act === 'inc' && it) setQty(key, qtyOf(it) + 1);
    else if (act === 'dec' && it) setQty(key, Math.max(1, qtyOf(it) - 1));
    else if (act === 'remove' && it) setQty(key, 0, true);
    else if (act === 'add-rec') add([upsellLine(Number(t.getAttribute('data-variant')))], t);
    else if (act === 'add-best') add([{ id: Number(t.getAttribute('data-variant')), quantity: 1 }], t);
    else if (act === 'checkout') checkout(t);
  });

  root.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') return close();
    if (e.key !== 'Tab') return;
    var f = panel.querySelectorAll('a[href],button:not([disabled]),[tabindex]:not([tabindex="-1"])');
    f = Array.prototype.filter.call(f, function (el) { return el.offsetParent !== null; });
    if (!f.length) return;
    if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
    else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
  });

  // Cart icon opens this drawer instead of the native one / cart page
  if (cfg.cartTriggerSelectors) {
    document.addEventListener('click', function (e) {
      var t = e.target.closest(cfg.cartTriggerSelectors);
      if (!t || root.contains(t) || /\/cart\/?$/.test(location.pathname)) return;
      e.preventDefault(); e.stopPropagation(); open();
    }, true);
  }

  // Product forms → AJAX add (capture phase so the theme's own handler doesn't double-add)
  if (cfg.interceptAddToCart) {
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form || !form.action || !/\/cart\/add/.test(form.getAttribute('action') || form.action)) return;
      if (form.hasAttribute('data-vcd-ignore')) return;
      e.preventDefault(); e.stopImmediatePropagation();
      var btn = e.submitter || form.querySelector('[type="submit"],[name="add"]');
      var fd; try { fd = new FormData(form, e.submitter); } catch (_) { fd = new FormData(form); }
      if (btn && btn.disabled) return;
      if (btn) btn.setAttribute('aria-disabled', 'true');
      add(fd).then(function () { if (btn) btn.removeAttribute('aria-disabled'); });
    }, true);
  }

  // Stay in sync when the theme or apps (bundle builders, quiz, upsell apps) change the cart via fetch
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || String(input || '');
    var method = ((init && init.method) || (input && input.method) || 'GET').toUpperCase();
    var p = nativeFetch(input, init);
    if (method === 'POST' && isOurPath(url)) {
      p.then(function (res) {
        if (!res.ok) return;
        if (/\/cart\/add/.test(url)) res.clone().json().then(markAdded).catch(function () {});
        afterExternalChange(url);
      }).catch(function () {});
    }
    return p;
  };

  // Same for themes/apps that still use XMLHttpRequest (jQuery-era themes, some upsell apps)
  var xOpen = XMLHttpRequest.prototype.open, xSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (m, u) { this._vcd = { m: String(m).toUpperCase(), u: String(u) }; return xOpen.apply(this, arguments); };
  XMLHttpRequest.prototype.send = function () {
    var x = this, i = x._vcd;
    if (i && i.m === 'POST' && isOurPath(i.u)) {
      x.addEventListener('load', function () {
        if (x.status < 200 || x.status >= 300) return;
        if (/\/cart\/add/.test(i.u)) { try { markAdded(JSON.parse(x.responseText)); } catch (e) {} }
        afterExternalChange(i.u);
      });
    }
    return xSend.apply(this, arguments);
  };

  function afterExternalChange(url) {
    refresh().then(function () { if (/\/cart\/add/.test(url)) afterAdd(); });
  }

  // Plain links like /cart/add?id=123&quantity=1 (used by some custom PDP buttons)
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href*="/cart/add"]');
    if (!a || root.contains(a)) return;
    var q = new URL(a.href, location.origin).searchParams, id = Number(q.get('id'));
    if (!id) return;
    e.preventDefault(); e.stopImmediatePropagation();
    add([{ id: id, quantity: Number(q.get('quantity')) || 1 }], a);
  }, true);

  // Back/forward cache and tab switches can leave a stale cart
  window.addEventListener('pageshow', function (e) { if (e.persisted) refresh(); });
  document.addEventListener('visibilitychange', function () { if (!document.hidden && S.cart) refresh(); });

  /* ---------- Boot ---------- */
  // Logo: placeholder box until cfg.logoUrl is set
  var logoImg = root.querySelector('[data-vcd-logo]'), logoPh = root.querySelector('.vcd__logo-ph');
  if (cfg.logoUrl && logoImg) {
    if (cfg.logoTone === 'white') logoImg.classList.add('is-white');
    logoImg.onload = function () { logoImg.hidden = false; if (logoPh) logoPh.hidden = true; };
    logoImg.onerror = function () { logoImg.hidden = true; if (logoPh) logoPh.hidden = false; };
    logoImg.src = cfg.logoUrl;
  }

  // Web font arriving after first paint changes text widths: re-fit once it's in
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { fontReady = true; if (S.cart && !S.open) render(); });

  window.VaanayaCart = { open: open, close: close, refresh: refresh, add: add };
  if (S.cart) setCart(S.cart); else refresh();
})();
